import React from 'react';

const partners = [
  { name: 'Ay Yıldız',        src: '/logos/ayyildiz.svg', h: 24 },
  { name: 'Ortel Mobile',      src: '/logos/ortel.svg',    h: 22 },
  { name: 'Lycamobile',        src: '/logos/lyca.svg',     h: 24 },
  { name: 'Lebara',            src: '/logos/lebara.svg',   h: 22 },
  { name: 'O2',                src: '/logos/o2.svg',       h: 28 },
  { name: 'Vodafone',          src: '/logos/vodafone.svg', h: 26 },
  { name: 'Deutsche Telekom',  src: '/logos/telekom.svg',  h: 20 }
];

// Duplicated once for a seamless marquee loop.
const track = [...partners, ...partners];

const PartnerRow = () => (
  <div className="pp-marquee relative w-full overflow-hidden">
    {/* Edge fade */}
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-24 bg-gradient-to-r from-white to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-24 bg-gradient-to-l from-white to-transparent z-10" />

    <div className="pp-marquee-track flex items-center gap-14 py-2">
      {track.map((p, i) => (
        <img
          key={p.name + i}
          src={p.src}
          alt={p.name}
          title={p.name}
          draggable={false}
          className="pp-logo shrink-0 w-auto"
          style={{ height: p.h + 'px' }}
          loading="lazy"
        />
      ))}
    </div>
  </div>
);

export default PartnerRow;
